module.exports = {
  FlashObject: {
    PluginName: "Flash Object",
    config: "Configuration",
  },
};
